import React, { Fragment, useRef } from 'react';
import { getVariantImageUrl, getVariantTitle } from '../../../../helpers';
import Checkbox from '../../../common/Checkbox';
import Editable from '../../../common/Editable';
import { Link } from 'react-router-dom';
import Button from '../../../common/Button';
import { useDrag, useDrop } from 'react-dnd';
import { useAutoTranslation } from '../../../../helpers/useAutoTranslation';

const TableDekstopItem = (props) => {
  const {
    item,
    index,
    features,
    setHoveredRow,
    handleMouseLeave,
    handleSelectVariant,
    selectedVariants,
    openVariant,
    variantsValues,
    rowProps,
    hoveredRow,
    variantsValidation,
    updateVariant,
    variants,
    deleteLoading,
    deleteVariant,
    moveFilter,
    i,
  } = props;

  const { t } = useAutoTranslation();

  const ref = useRef(null);
  const [, drop] = useDrop({
    accept: 'filter',
    // drop: () => handleUpdateProducts(currentProducts), //fix
    hover(item, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;
      if (dragIndex === hoverIndex) {
        return;
      }
      const hoverBoundingRect = ref.current.getBoundingClientRect();
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      const clientOffset = monitor.getClientOffset();
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      moveFilter(dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
  });

  const [{ isDragging }, drag] = useDrag({
    item: { type: 'filter', item, index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });
  drag(drop(ref));

  let defective = item?.stock?.reduce((a, c) => {
    a += c.stockDefective;
    return a;
  }, 0);

  const variantId = item.temporaryId ? item.temporaryId : item.id;
  const variantTitle = getVariantTitle(item, features);
  return (
    <tr
      key={variantId}
      ref={ref}
      onMouseEnter={() => setHoveredRow(variantId)}
      onMouseLeave={handleMouseLeave}
      className="grab"
    >
      <td className="checkbox-td" onClick={() => handleSelectVariant(variantId)}>
        <Checkbox
          id={`variants-checkbox-${variantId}`}
          name={`variants-checkbox-${variantId}`}
          checked={selectedVariants.indexOf(variantId) !== -1}
        />
      </td>
      <td
        style={{ width: '76px' }}
        onClick={() => (!item.isNew ? openVariant(item) : null)}
        className="table-item-image"
      >
        <div
          className="image-block"
          style={{ backgroundImage: `url(${getVariantImageUrl(item, 100)})` }}
        />
      </td>
      <td onClick={() => (!item.isNew ? openVariant(item) : null)} className="table-item-title">
        {item.isNew || item.unsaved ? (
          <span className="badge badge-primary mr-1">{t('Не сохранен')}</span>
        ) : null}
        {variantTitle}
        <span className="variant-id-span">
          {item.id} {item.extId ? `(${item.extId})` : null}
        </span>
      </td>
      <React.Fragment>
        {variantsValues[variantId]
          ? Object.keys(variantsValues[variantId]).map((key) => (
              <td key={key}>
                <Editable
                  placeholder={rowProps.find((i) => i.prop === key).title}
                  value={variantsValues[variantId][key]}
                  currentInput={hoveredRow === variantId}
                  preventFocus
                  notSaveOnEnter
                  isInvalid={
                    variantsValidation !== true &&
                    variantsValidation.index === i &&
                    variantsValidation.prop === key
                  }
                  onChange={(e) => updateVariant(e.target.value, item, key)}
                />
              </td>
            ))
          : null}
        <td>
          {item.stock && item.stock.length ? (
            <Fragment>
              {item.stock.reduce((a, c) => {
                a += c.stockAvailable;
                return a;
              }, 0)}
              <br />
              <Link
                to={{
                  pathname: '/orders',
                  state: {
                    reservedVariantId: item.id,
                  },
                }}
                className="variant-stock-span"
              >
                {`${t('Резерв')}: ${item.stock.reduce((a, c) => {
                  a += c.stockReserved;
                  return a;
                }, 0)}`}
              </Link>

              {defective ? (
                <Fragment>
                  <Link
                    to={{
                      pathname: '/orders',
                      state: {
                        reservedVariantId: item.id,
                      },
                    }}
                    className="variant-stock-span"
                  >
                    {t('Брак')} {defective}
                  </Link>
                </Fragment>
              ) : null}
            </Fragment>
          ) : null}
        </td>
        <td>
          {variants.length > 1 ? (
            <Button
              classType="btn-link"
              type="button"
              disabled={deleteLoading}
              text={
                deleteLoading ? (
                  ''
                ) : (
                  <i className="fe-trash-2" style={{ color: '#6c757d', fontSize: '20px' }} />
                )
              }
              loading={deleteLoading}
              onClick={() => deleteVariant(item)}
            />
          ) : null}
        </td>
      </React.Fragment>
    </tr>
  );
};

export default TableDekstopItem;
